import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { OpenMasterpassInfoAction } from './masterpass-info-dialog.action';

/* @ngInject */
export default class MasterpassInfoDialogController implements ActionHandler {

  protected dialogElement;
  protected dialogOptions;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService
  ) {
    this.actionDispatcher.register(this);
  }

 
  public $postLink() {
    this.dialogElement = this.$element.find('#masterpass-info').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenMasterpassInfoAction) {
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onClose() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/buy/masterpass-info-dialog/masterpass-info-dialog.controller.ts